import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const putEditApproversWorkflow = createApi(`EditApproversWorkflowSlice`,"PUT");

const EditApproversWorkflowSlice = createSlice({
  name: 'EditApproversWorkflowSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(putEditApproversWorkflow.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(putEditApproversWorkflow.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(putEditApproversWorkflow.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default EditApproversWorkflowSlice.reducer;